import { DESKTOP_MIN_WIDTH, VIDEO_ASPECT_RATIO } from '@bg-shared/constants/constants';
import { getTypedCssVariable } from '@bg-shared/utils/getCssVariable';

export const getIframeHeightToFitVideo = (minWindowWidth = DESKTOP_MIN_WIDTH): number | null => {
    if (window.innerWidth >= minWindowWidth) {
        const headerHeight = parseInt(getTypedCssVariable<string>('--header-height'), 10);
        const videoHeight = window.innerWidth / VIDEO_ASPECT_RATIO;

        return Math.floor(headerHeight + videoHeight);
    }

    return null;
};
